import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HistoryIcon from '@mui/icons-material/History';
import { Link, useNavigate, useParams } from 'react-router-dom';
import S from './ListDam.module.css'
import D from '../images/history.svg'

import {  useSelector } from 'react-redux';


import apiService from '../api/ApiService';
import { useGlobalContext } from '../Components/Context';
import CattleHistoryCompare from '../Components/HistoryCompare/CattleHistoryCompare';
import SensorHistoryCompare from '../Components/HistoryCompare/SensorHistoryCompare';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { DateRangeRounded, KeyboardBackspace } from '@mui/icons-material';
import useHistory from '../Components/CustomHooks/useHistory';
import { Pagination } from '@mui/material';
import SensorHistoryParameterCard from '../Components/cardThemes/SensorHistoryParameterCard';
import EmptyReturn from '../Components/EmptyReturn';
const moment=require('moment-jalaali')
export default function ListSensorParamHistory() {
  const navigate=useNavigate()
  const flag='sensorParameter'
  const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
  const {total,page,handlePage,data,SData,setSdata,selectedDayRange, setSelectedDayRange,renderCustomInput}=useHistory(flag)
  const {currentTheme}=useSelector(state=>state.p.admin)

  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} style={{width:'70px',height:'70px'}} src={D}/>
        <h2> تاریخچه پارامتر سنسور</h2>
        </div>
        <div onClick={()=>{navigate(-1)}}  className='backButton' >
          <KeyboardBackspace fontSize='large'/>
        </div>
       
           
      </div>
        <hr/>
        <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
        {!currentTheme&&<div className={S.TabForAllAnnimLICon}>
          
          
          <div className={S.AnimContentLI} data-aos='fade'>
          {data.length?<table>
              <thead>
                <tr>
                  <th>
                    ردیف
                  </th>
                  
                  <th>
                     تاریخ
                  </th>
                  <th>
                     جزئیات
                  </th>
                 
                </tr>
              </thead>
              <tbody>
                {
                  data?.length&&data?.map((item,index)=>{
                    const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    
                    <td>
                      {pbirth}
  
                    </td>
                    <td>
                    <span onClick={()=>{
                      setSdata(item);openModalls()
                    }} className='visitDetailTable'>مشاهده</span>
                    </td>
                    
                    
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>
        </div>}
        {currentTheme&&<SensorHistoryParameterCard data={data}/>}
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
        {!currentTheme&&isOpenModal&&<SensorHistoryCompare data={SData?.currentJson} data2={SData?.newJson}/>}
    </div>
  );
}